import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { legacy_createStore, applyMiddleware, compose } from 'redux';

import { IS_DEBUG_ENVIRONMENT, IS_TEST_ENVIRONMENT } from '#/config';
import { SAVE_STATE_MAX_DELAY_MS } from '#/config/constants';
import { identifyWalletInPosthog } from '#/lib/analyticsPosthogSetup';
import { waitAsync } from '#/lib/promiseTools';
import { throttle } from '#/lib/throttle';

import { loadState, saveState } from './caching';
import { customDispatchMiddleware } from './dispatchMiddleware';
import { initialMiddleware as runInitialMiddleware } from './initialMiddleware';
import { ReduxState, rootReducer } from './storeCore';
import { setStore, ReduxStore } from './storeHolder';

const persistedState = loadState();

if (persistedState?.wallet?.walletAddress) {
  identifyWalletInPosthog(persistedState?.wallet?.walletAddress);
}

let store: ReduxStore | null = null;

const startGlobalSubscribtions = async () => {
  await waitAsync();

  while (!store?.dispatch) {
    await waitAsync(100);
  }

  runInitialMiddleware(store.dispatch);

  store.subscribe(
    throttle(() => {
      if (store) {
        persistStateToStorage(store.getState());
      }
    }, SAVE_STATE_MAX_DELAY_MS)
  );
};

// Create a Redux store holding the state of your app.
// Its API is { subscribe, dispatch, getState }.
const composeEnhancers = IS_DEBUG_ENVIRONMENT
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  : compose;

const createReduxStore = () => {
  store = legacy_createStore(
    rootReducer,
    persistedState ?? ({} as any),
    composeEnhancers(
      /* Here you can add custom enhancers (middlewares) */
      applyMiddleware(
        customDispatchMiddleware as any
        // , routerMiddleware
      )
    )
  );
  setStore(store);
  if (!IS_TEST_ENVIRONMENT) {
    startGlobalSubscribtions();
  }
  return store;
};

createReduxStore();

function persistStateToStorage(state: ReduxState) {
  saveState(state);
}

// export const saveStoreStateAndReload = (location?: string) => {
//   saveStoreStateImmediately();
//   setTimeout(() => {
//     if (location) {
//       window.location.replace(location);
//     } else {
//       window.location.reload();
//     }
//   });
// };

// function saveStoreStateImmediately() {
//   if (!store) {
//     console.error('Save unknown store');
//     return;
//   }
//   persistStateToStorage(store.getState());
// }

export function ReduxProvider({ children }: { children: ReactNode }) {
  return <Provider store={store as any}>{children}</Provider>;
}

// https://vitejs.dev/guide/api-hmr.html
// https://gist.github.com/markerikson/dc6cee36b5b6f8d718f2e24a249e0491
// https://stackoverflow.com/questions/72883410/how-can-i-make-the-pinia-store-to-hot-reload-the-changes

// if (import.meta.hot) {
//   import.meta.hot.accept(newModule => {
//     if (newModule) {
//       // newModule is undefined when SyntaxError happened
//       console.log('TEST SETUP UPDATE :: SETUP', newModule);
//     }
//   });
// }
// if (import.meta.hot) {
//   // import { ReduxState, rootReducer } from './storeCore';
//   import.meta.hot.accept('./storeCore', () =>
//     // eslint-disable-next-line @typescript-eslint/no-var-requires
//     store.replaceReducer(require('./storeCore').rootReducer)
//   );
// }
// if (import.meta.hot) {
//   import.meta.hot.dispose(_data => {
//     // cleanup side effect
//   });
// }
// if(__DEV__) {
//   // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
//   if(module.hot) {
//       module.hot.accept("../reducers/rootReducer", () =>
//           store.replaceReducer(require("../reducers/rootReducer").default)
//       );

//       module.hot.accept('../sagas/SagaManager', () => {
//           SagaManager.cancelSagas(store);
//           require('../sagas/SagaManager').default.startSagas(sagaMiddleware);
//       });
//   }
// }
